const newSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7.25" stroke-width="1.5"/><polygon stroke-width="0" points="7.4 4.9 5 9.1 7.1 9.1 5.9 12.1 11 7.3 8.42 7.3 10.4 4.9"/></svg>',
};

export { newSubtle as default };
